var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVetPropLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 128,
    viewBox: "0 0 201 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.92773,
    y: 4,
    width: 191.861,
    height: 120,
    rx: 6,
    fill: "#F9FBFF",
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.114 106.476V64.759H147.783C148.874 64.4607 149.91 63.9275 150.784 63.129C152.429 61.6262 153.293 59.4863 153.152 57.262C153.012 55.0377 151.889 53.0238 150.069 51.7374L100.883 17L51.7582 51.8047C49.9607 53.0776 48.8414 55.0683 48.6862 57.2657C48.5322 59.4631 49.3607 61.592 50.9615 63.1046C51.9036 63.996 53.0425 64.5658 54.2388 64.8605H53.6547V106.476H45.8965V110.145H155.872V106.476H148.114ZM134.212 106.476H121.467V75.2556H134.213V106.476H134.212ZM144.448 106.476H138.224V71.2411H117.455V106.476H57.3205V64.9645C58.3384 64.7774 59.3294 64.3861 60.2154 63.7588L100.887 34.9446L141.621 63.7135C142.483 64.3225 143.452 64.6954 144.448 64.885V106.476ZM143.735 60.7152L100.882 30.4508L58.0965 60.7641C56.6827 61.7656 54.7385 61.6299 53.4787 60.4376C52.6796 59.682 52.2653 58.6206 52.3435 57.5237C52.4217 56.4268 52.9802 55.4339 53.8758 54.7981L100.886 21.4926L147.954 54.7345C148.863 55.3752 149.424 56.3804 149.494 57.4907C149.565 58.601 149.132 59.6685 148.304 60.4266C147.045 61.5761 145.124 61.6971 143.735 60.7152Z",
    fill: "#0F2F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0317 71.4135V103.502H111.064V71.4135H64.0317ZM107.398 85.6237H89.3812V75.0819H107.398V85.6237ZM85.7153 75.0819V85.6237H67.6976V75.0819H85.7153ZM67.6976 89.2921H85.7153V99.8339H67.6976V89.2921ZM89.3812 99.8339V89.2921H107.398V99.8339H89.3812Z",
    fill: "#0F2F66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.867 43.3832L75.5239 61.3388L126.25 61.3095L100.867 43.3832ZM102.703 49.1695L114.707 57.6484L102.703 57.6545V49.1695ZM99.0368 49.1756V57.657L87.0555 57.6631L99.0368 49.1756Z",
    fill: "#0F2F66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetPropLogo);
export default __webpack_public_path__ + "static/media/vet-prop-logo.d97972e73199434415a5895f80292051.svg";
export { ForwardRef as ReactComponent };